import React from "react";
import { Button, Container, Fill, Group } from "./styles";
export var RadioGroup = function (_a) {
    var selected = _a.selected, onClick = _a.onClick, options = _a.options, horizontal = _a.horizontal, customColor = _a.customColor, disabled = _a.disabled;
    var colorToUse = customColor ? customColor : "#2ec9b7";
    return (React.createElement(Group, { horizontal: horizontal }, options.map(function (op) { return (React.createElement(Container, { disabled: disabled, onClick: function () {
            if (onClick && !disabled) {
                onClick(op.value);
            }
        } },
        React.createElement(Button, { customColor: colorToUse, disabled: disabled },
            React.createElement(Fill, { thisSelected: selected === op.value, customColor: colorToUse, disabled: disabled })),
        React.createElement("span", null, op.label))); })));
};
//# sourceMappingURL=index.js.map